import { render, staticRenderFns } from "./WorkerLodging.vue?vue&type=template&id=73efb61e"
import script from "./WorkerLodging.vue?vue&type=script&lang=js"
export * from "./WorkerLodging.vue?vue&type=script&lang=js"
import style0 from "./WorkerLodging.vue?vue&type=style&index=0&id=73efb61e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports